import React, { useState, useRef, useCallback } from "react";
import { Button, FormGroup, Label, Row } from "reactstrap";
import Image from "react-bootstrap/Image";
import { IDENTITY_VERIFICATION_INSTRUCTIONS } from "../../../../constants/checkinType";

const Passport = ({ setPassport }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const filePhotoRef = useRef(null);

  const handleImageChange = useCallback(
    async (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        setPassport(base64);
      };
      reader.readAsDataURL(file);

      const fileBlob = URL.createObjectURL(file);
      setSelectedImage(fileBlob);
    },
    [setSelectedImage, setPassport]
  );

  const handleButtonClick = useCallback(() => {
    filePhotoRef.current.click();
  }, [filePhotoRef]);

  return (
    <Row>
      <FormGroup className="form-group col">
        <div className="signature-flex">
          <Label for="passport">{IDENTITY_VERIFICATION_INSTRUCTIONS}</Label>
          {selectedImage && (
            <Button
              className="button-signature checkin-button--color"
              onClick={handleButtonClick}
            >
              <span>changer</span>
            </Button>
          )}
        </div>
        <input
          id="passport"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          required
          ref={filePhotoRef}
          style={{ display: "none" }}
        />
        {!selectedImage && (
          <div className="form-control signature-flex">
            <Button
              className="button-signature checkin-button--color"
              onClick={handleButtonClick}
            >
              <span>choisir</span>
            </Button>
            <span>Pas encore choisi fichier</span>
          </div>
        )}
        {selectedImage && (
          <Image
            src={selectedImage}
            alt="passport-image"
            fluid
            className="checkin-header"
          />
        )}
      </FormGroup>
    </Row>
  );
};

export default Passport;
